import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

// Create axios instance for the new API
const slugApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add authorization token if available
slugApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ProlegionAccessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const createInvestorUrl = (slugData) => {
  return slugApi.post("/slug/create", slugData);
};

export const getInvestorUrls = (page, limit, status = null) => {
  let url = `/slug/list?page=${page}&limit=${limit}`;
  if (status) {
    // Ensure status is uppercase (EXPIRED, DELETED, ACTIVE)
    const statusUpper = status.toUpperCase();
    url += `&status=${statusUpper}`;
  }
  return slugApi.get(url);
};

export const getSlugById = (slugId) => {
  return slugApi.get(`/slug/${slugId}`);
};

export const expireSlug = (slugId) => {
  return slugApi.post(`/slug/expire/${slugId}`);
};

export const deleteInvestorUrl = (slugId) => {
  return slugApi.delete(`/slug/${slugId}?permanent=true`);
};

export const getCustomSlugRequests = (page, limit) => {
  let url = `/slug/custom-slug-request/list?page=${page}&limit=${limit}`;
  return slugApi.get(url);
};

